import type { OnboardingStepId } from '../../models/organization';

export type OnboardingStepMeta = {
  id: OnboardingStepId;
  title: string;
  why: string;
  cta: string;
  route: string;
};

export const ONBOARDING_STEPS: OnboardingStepMeta[] = [
  {
    id: 'intro',
    title: 'Prepara tu negocio',
    why: 'En cuatro pasos tendrás tu primera venta aprobada.',
    cta: 'Empezar',
    route: '/home',
  },
  {
    id: 'product',
    title: 'Agrega tu primer producto',
    why: 'Así tu equipo puede venderlo desde el catálogo.',
    cta: 'Crear producto',
    route: '/inventory',
  },
  {
    id: 'client',
    title: 'Registra un cliente',
    why: 'Cada venta necesita a quién facturar.',
    cta: 'Crear cliente',
    route: '/clients',
  },
  {
    id: 'order',
    title: 'Crea tu primera venta',
    why: 'Elige el cliente, el producto y el pago.',
    cta: 'Crear venta',
    route: '/orders',
  },
  {
    id: 'approve',
    title: '¡Ahora aprueba la venta!',
    why: 'Sin aprobar no cuenta como venta cerrada ni baja el inventario.',
    cta: 'Aprobar venta',
    route: '/orders',
  },
  {
    id: 'done',
    title: '¡Primera venta lista!',
    why: 'Tu negocio ya está en marcha.',
    cta: 'Ir al inicio',
    route: '/home',
  },
];

export function getStepMeta(id: OnboardingStepId | null | undefined): OnboardingStepMeta {
  return (
    ONBOARDING_STEPS.find(s => s.id === id) ?? ONBOARDING_STEPS[0]
  );
}
